import AirDatepicker from 'air-datepicker';
import 'air-datepicker/air-datepicker.css';
import { getLocalItem, setLocalItem } from '../../store/localStore';
import { isMediumScreen, isSmallScreen } from '../../../../../utils';
import { dateDiffInDays, getStartDatePlusOneYear, getThreeMonthsFromNow, } from '../../../utils';
import { ANNUAL_COVER_VALUE } from '../../../constants';
export function initDatePicker(form) {
    const now = new Date();
    const oneYearFromNow = new Date(now.getFullYear() + 1, now.getMonth(), now.getDate() - 1);
    const threeMonthsFromNow = getThreeMonthsFromNow();
    const coverType = getLocalItem('coverType');
    const isAnnualCover = coverType === ANNUAL_COVER_VALUE;
    const startDateInput = document.getElementById('start-date');
    const startDateContainer = document.querySelector('.start-date__container');
    const endDateContainer = document.querySelector('.end-date__container');
    const endDateInput = document.getElementById('end-date');
    function getDaysInCurrentYear() {
        const currentYear = now.getFullYear();
        return new Date(currentYear, 1, 29).getDate() === 29 ? 366 : 365; // leap year check with feb
    }
    if (startDateInput && endDateInput) {
        const startPicker = new AirDatepicker(startDateInput, {
            onSelect({ date }) {
                var _a;
                if (date && date instanceof Date) {
                    if ((endPicker.selectedDates.length > 0 &&
                        endPicker.selectedDates[0] < date) ||
                        (!isAnnualCover &&
                            ((_a = endPicker.selectedDates[0]) === null || _a === void 0 ? void 0 : _a.getTime()) - date.getTime()) /
                            (1000 * 60 * 60 * 24) >
                            getDaysInCurrentYear() - 1 // -1 since the current picker range working with 364/365 because we will count both start and end date
                    ) {
                        endPicker.clear();
                        form.set('endDate', '');
                        endDateContainer.classList.remove('selected');
                    }
                    const selectedStartDate = new Date(Array.isArray(date) ? date[0].getTime() : date.getTime());
                    const startDatePlusOneYear = new Date(selectedStartDate.setDate(selectedStartDate.getDate() + 364));
                    endPicker.update({
                        startDate: date,
                        minDate: date,
                        maxDate: isAnnualCover ? threeMonthsFromNow : startDatePlusOneYear,
                    });
                    const formattedDate = date.toLocaleString('it-IT', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                    });
                    form.set('startDate', formattedDate);
                    startDateContainer.classList.add('selected');
                    setLocalItem('startDate', formattedDate);
                    startPicker.hide();
                }
                else {
                    form.set('startDate', '');
                    setLocalItem('startDate', '');
                }
            },
            isMobile: isSmallScreen(),
            minDate: new Date(),
            maxDate: isAnnualCover ? threeMonthsFromNow : oneYearFromNow,
            dateFormat: 'dd/MM/yyyy',
            locale: {
                days: [
                    'Domenica',
                    'Lunedì',
                    'Martedì',
                    'Mercoledì',
                    'Giovedì',
                    'Venerdì',
                    'Sabato',
                ],
                daysShort: ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
                daysMin: ['Do', 'Lu', 'Ma', 'Me', 'Gi', 'Ve', 'Sa'],
                months: [
                    'Gennaio',
                    'Febbraio',
                    'Marzo',
                    'Aprile',
                    'Maggio',
                    'Giugno',
                    'Luglio',
                    'Agosto',
                    'Settembre',
                    'Ottobre',
                    'Novembre',
                    'Dicembre',
                ],
                monthsShort: [
                    'Gen',
                    'Feb',
                    'Mar',
                    'Apr',
                    'Mag',
                    'Giu',
                    'Lug',
                    'Ago',
                    'Set',
                    'Ott',
                    'Nov',
                    'Dic',
                ],
                today: 'Oggi',
                clear: 'Reset',
                dateFormat: 'dd/MM/yyyy',
                firstDay: 1,
            },
        });
        const endPicker = new AirDatepicker(endDateInput, {
            onSelect({ datepicker, date }) {
                if (date) {
                    const formattedDate = date.toLocaleString('it-IT', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                    });
                    form.set('endDate', formattedDate);
                    const dateDiff = dateDiffInDays(form.get('startDate'), form.get('endDate'));
                    endDateContainer.classList.add('selected');
                    form.set('numberOfTripDays', dateDiff);
                    setLocalItem('numberOfTripDays', dateDiff.toString());
                    setLocalItem('endDate', formattedDate);
                    endPicker.hide();
                }
                else {
                    form.set('endDate', '');
                    setLocalItem('endDate', '');
                }
            },
            isMobile: isSmallScreen(),
            minDate: new Date(),
            maxDate: isAnnualCover
                ? threeMonthsFromNow
                : getLocalItem('startDate')
                    ? getStartDatePlusOneYear(getLocalItem('startDate'))
                    : oneYearFromNow,
            dateFormat: 'dd/MM/yyyy',
            locale: {
                days: [
                    'Domenica',
                    'Lunedì',
                    'Martedì',
                    'Mercoledì',
                    'Giovedì',
                    'Venerdì',
                    'Sabato',
                ],
                daysShort: ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
                daysMin: ['Do', 'Lu', 'Ma', 'Me', 'Gi', 'Ve', 'Sa'],
                months: [
                    'Gennaio',
                    'Febbraio',
                    'Marzo',
                    'Aprile',
                    'Maggio',
                    'Giugno',
                    'Luglio',
                    'Agosto',
                    'Settembre',
                    'Ottobre',
                    'Novembre',
                    'Dicembre',
                ],
                monthsShort: [
                    'Gen',
                    'Feb',
                    'Mar',
                    'Apr',
                    'Mag',
                    'Giu',
                    'Lug',
                    'Ago',
                    'Set',
                    'Ott',
                    'Nov',
                    'Dic',
                ],
                today: 'Oggi',
                clear: 'Reset',
                dateFormat: 'dd/MM/yyyy',
                firstDay: 1,
            },
        });
        function showPicker(picker, container) {
            if (!picker.isVisible) {
                picker.show();
                if (!isSmallScreen() && isMediumScreen()) {
                    centerElement(container);
                }
            }
        }
        function centerElement(element) {
            const rect = element.getBoundingClientRect();
            const scrollTop = window.scrollY || document.documentElement.scrollTop;
            const scrollLeft = window.scrollX || document.documentElement.scrollLeft;
            window.scrollTo({
                top: rect.top + scrollTop - (window.innerHeight - rect.height) / 2,
                left: rect.left + scrollLeft - (window.innerWidth - rect.width) / 2,
                behavior: 'smooth',
            });
        }
        function handleOutsideClick(event) {
            const allowedClassNames = [
                'air-datepicker-nav--title',
                'air-datepicker-nav--action',
                'air-datepicker-cell',
                'air-datepicker-nav',
                'air-datepicker--content',
                'air-datepicker-body',
                'air-datepicker-body--day-names',
                'air-datepicker-body--day-name',
            ];
            const clickedElement = event.target;
            const isAllowedClass = allowedClassNames.some((className) => clickedElement.classList.contains(className));
            if (startPicker.visible &&
                !startDateContainer.contains(event.target) &&
                !isAllowedClass) {
                startPicker.hide();
            }
            if (endPicker.visible &&
                !endDateContainer.contains(event.target) &&
                !isAllowedClass) {
                endPicker.hide();
            }
        }
        if (isMediumScreen()) {
            document.addEventListener('click', handleOutsideClick);
        }
        else {
        }
        startDateContainer.addEventListener('click', (event) => {
            event.stopPropagation(); // this is to Prevent the event from bubbling up to the document
            if (isMediumScreen()) {
                startDateContainer.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                });
                if (!startPicker.visible) {
                    showPicker(startPicker, startDateContainer);
                }
                if (endPicker.visible) {
                    endPicker.hide();
                }
            }
            else {
                showPicker(startPicker, startDateContainer);
            }
        });
        endDateContainer.addEventListener('click', (event) => {
            event.stopPropagation(); // this is to Prevent the event from bubbling up to the document
            if (isMediumScreen()) {
                startDateContainer.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                });
                if (!endPicker.visible) {
                    showPicker(endPicker, endDateContainer);
                }
                if (startPicker.visible) {
                    startPicker.hide();
                }
            }
            else {
                showPicker(endPicker, endDateContainer);
            }
        });
        return [startPicker, endPicker];
    }
}
